import { defMathOpN } from "./compile/emit.js";
const [divN, divN2, divN3, divN4] = defMathOpN("/");
export {
  divN,
  divN2,
  divN3,
  divN4
};
